import { ComponentType } from 'preact'
import { YogaWidgetBase, InitData } from '../../core'
import { ContactInfoWidget } from './ContactInfoWidget'

class HoldstyringContactInfoElement extends YogaWidgetBase {
  protected getComponent(): ComponentType<{ initData: InitData }> {
    return ContactInfoWidget
  }

  // Supported HTML attributes:
  //   title="Find os"             — heading above the contact card (default: none)
  //   show-opening-hours="false"  — hide the hours table (default: visible)
  protected getWidgetProps() {
    return {
      title: this.getAttribute('title') || null,
      showOpeningHours: this.getAttribute('show-opening-hours') !== 'false',
    }
  }
}

if (!customElements.get('holdstyring-contact-info')) {
  customElements.define('holdstyring-contact-info', HoldstyringContactInfoElement)
}

export { HoldstyringContactInfoElement }
